import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';

interface MultiSelectChipsProps {
  label: string;
  options: readonly string[];
  value: string[];
  onChange: (value: string[]) => void;
  error?: string;
  required?: boolean;
}

export function MultiSelectChips({
  label,
  options,
  value,
  onChange,
  error,
  required,
}: MultiSelectChipsProps) {
  const toggle = (option: string) => {
    if (value.includes(option)) {
      onChange(value.filter((v) => v !== option));
    } else {
      onChange([...value, option]);
    }
  };

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" fontWeight={500} sx={{ mb: 1 }} color={error ? 'error' : 'text.primary'}>
        {label}
        {required && <Box component="span" sx={{ color: 'error.main', ml: 0.3 }}>*</Box>}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {options.map((option) => (
          <Chip
            key={option}
            label={option}
            onClick={() => toggle(option)}
            variant={value.includes(option) ? 'filled' : 'outlined'}
            color={value.includes(option) ? 'primary' : 'default'}
            sx={{
              cursor: 'pointer',
              fontWeight: value.includes(option) ? 600 : 400,
              transition: 'all 0.15s',
              ...(value.includes(option) && {
                bgcolor: 'primary.main',
                color: 'primary.contrastText',
                borderColor: 'primary.main',
                '&:hover': { bgcolor: 'primary.light' },
              }),
            }}
          />
        ))}
      </Box>
      {error && <FormHelperText error>{error}</FormHelperText>}
    </Box>
  );
}
